<template>
  <div class="page-container">
    <PageHeader title="PK规则" show-breadcrumb>
      <template #actions>
        <el-button type="primary" icon="el-icon-check" size="small" :loading="saving" @click="handleSave">保存规则</el-button>
      </template>
    </PageHeader>

    <el-card v-loading="loading" shadow="never" class="rule-card">
      <div slot="header">
        <span style="font-weight:600;">PK 全局规则配置</span>
        <span style="color:#909399; font-size:12px; margin-left:10px;">配置当前项目下所有 PK 对战的通用规则</span>
      </div>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="160px" size="small" style="max-width:640px;">
        <el-form-item label="PK题目数" prop="pkNums">
          <el-input-number v-model="form.pkNums" :min="1" controls-position="right" />
          <span class="rule-tip">每场 PK 对战的题目数量（≥1）</span>
        </el-form-item>
        <el-form-item label="单题倒计时(秒)" prop="pkCountdownSecond">
          <el-input-number v-model="form.pkCountdownSecond" :min="5" controls-position="right" />
          <span class="rule-tip">每道题的答题倒计时秒数（≥5）</span>
        </el-form-item>
        <el-form-item label="每题分值" prop="pkScore">
          <el-input-number v-model="form.pkScore" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">答对一题得分（0-100）</span>
        </el-form-item>
        <el-form-item label="胜利得分" prop="pkPointsWin">
          <el-input-number v-model="form.pkPointsWin" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 胜利方额外得分（0-100）</span>
        </el-form-item>
        <el-form-item label="失败得分" prop="pkPointsLose">
          <el-input-number v-model="form.pkPointsLose" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 失败方得分（0-100，需小于胜利得分）</span>
        </el-form-item>
        <el-form-item label="平局得分" prop="pkPointsDraw">
          <el-input-number v-model="form.pkPointsDraw" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 平局双方得分（0-100）</span>
        </el-form-item>
        <el-form-item label="连胜单次加分" prop="pkPointsWinningStreak">
          <el-input-number v-model="form.pkPointsWinningStreak" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">每多连胜一场额外得分（0-100）</span>
        </el-form-item>
        <el-form-item label="连胜最高加分" prop="pkPointsWinningStreakMax">
          <el-input-number v-model="form.pkPointsWinningStreakMax" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">连胜加分的上限（0-100）</span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import { getPkqRuleGlobalDetails, updatePkqRuleGlobal } from '@/api/api'

export default {
  name: 'PkqRule',
  components: { PageHeader },
  data () {
    // 失败得分必须小于胜利得分
    const validateLose = (rule, value, callback) => {
      if (value != null && this.form.pkPointsWin != null && Number(value) >= Number(this.form.pkPointsWin)) {
        callback(new Error('失败得分需小于胜利得分'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      saving: false,
      form: {
        prgId: null,
        pkNums: 1,
        pkCountdownSecond: 15,
        pkScore: 10,
        pkPointsWin: 0,
        pkPointsLose: 0,
        pkPointsDraw: 0,
        pkPointsWinningStreak: 0,
        pkPointsWinningStreakMax: 0
      },
      rules: {
        pkNums: [{ type: 'number', min: 1, message: '题目数需 ≥ 1', trigger: 'change' }],
        pkCountdownSecond: [{ type: 'number', min: 5, message: '倒计时需 ≥ 5 秒', trigger: 'change' }],
        pkScore: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWin: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsLose: [
          { type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' },
          { validator: validateLose, trigger: 'change' }
        ],
        pkPointsDraw: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWinningStreak: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWinningStreakMax: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }]
      }
    }
  },
  created () { this.fetchDetail() },
  methods: {
    // 获取当前项目 PK 全局规则（不存在后端会自动初始化）
    async fetchDetail () {
      this.loading = true
      try {
        const res = await getPkqRuleGlobalDetails()
        const d = res.data || {}
        this.form = {
          prgId: d.prgId || null,
          pkNums: Number(d.pkNums) || 1,
          pkCountdownSecond: Number(d.pkCountdownSecond) || 15,
          pkScore: Number(d.pkScore) || 0,
          pkPointsWin: Number(d.pkPointsWin) || 0,
          pkPointsLose: Number(d.pkPointsLose) || 0,
          pkPointsDraw: Number(d.pkPointsDraw) || 0,
          pkPointsWinningStreak: Number(d.pkPointsWinningStreak) || 0,
          pkPointsWinningStreakMax: Number(d.pkPointsWinningStreakMax) || 0
        }
      } catch (e) {} finally {
        this.loading = false
      }
    },
    handleSave () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          await updatePkqRuleGlobal(this.form)
          this.$message.success('保存成功')
          this.fetchDetail()
        } catch (e) {} finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-card { max-width: 880px; margin: 0 auto; }
.rule-tip { display: inline-block; margin-left: 12px; color: #909399; font-size: 12px; }
</style>
